/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type UpdateGuardrailsRequest = {
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
  updateGuardrailsRequest: components.UpdateGuardrailsRequest;
};

/** @internal */
export const UpdateGuardrailsRequest$inboundSchema: z.ZodType<
  UpdateGuardrailsRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  "X-On-Behalf-Of": z.string().optional(),
  UpdateGuardrailsRequest: components.UpdateGuardrailsRequest$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "X-On-Behalf-Of": "xOnBehalfOf",
    "UpdateGuardrailsRequest": "updateGuardrailsRequest",
  });
});
/** @internal */
export type UpdateGuardrailsRequest$Outbound = {
  "X-On-Behalf-Of"?: string | undefined;
  UpdateGuardrailsRequest: components.UpdateGuardrailsRequest$Outbound;
};

/** @internal */
export const UpdateGuardrailsRequest$outboundSchema: z.ZodType<
  UpdateGuardrailsRequest$Outbound,
  z.ZodTypeDef,
  UpdateGuardrailsRequest
> = z.object({
  xOnBehalfOf: z.string().optional(),
  updateGuardrailsRequest: components.UpdateGuardrailsRequest$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    xOnBehalfOf: "X-On-Behalf-Of",
    updateGuardrailsRequest: "UpdateGuardrailsRequest",
  });
});

export function updateGuardrailsRequestToJSON(
  updateGuardrailsRequest: UpdateGuardrailsRequest,
): string {
  return JSON.stringify(
    UpdateGuardrailsRequest$outboundSchema.parse(updateGuardrailsRequest),
  );
}
export function updateGuardrailsRequestFromJSON(
  jsonString: string,
): SafeParseResult<UpdateGuardrailsRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => UpdateGuardrailsRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'UpdateGuardrailsRequest' from JSON`,
  );
}
